import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import Reviews from './pages/Reviews';
import Refunds from './pages/Refunds';
import Wishlist from './pages/Wishlist';
import Agents from './pages/Agents';
import Settings from './pages/Settings';
import Invoices from './pages/Invoices';
import Admin from './pages/Admin';
import Products from './pages/Products';
import ScannerMonitor from './pages/ScannerMonitor';
import DeliveryStatus from './pages/DeliveryStatus';

function storedUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || 'null');
  } catch {
    return null;
  }
}

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function StandardOnly({ children }) {
  return storedUser()?.role === 'delivery_only'
    ? <Navigate to="/delivery-status" replace />
    : children;
}

function DeliveryAccess({ children }) {
  return storedUser() ? children : <Navigate to="/login" replace />;
}

function ScannerMonitorAccess({ children }) {
  const user = storedUser();
  if (!user) return <Navigate to="/login" replace />;
  return (user.plan === 'admin' || user.plan === 'mirror')
    ? children
    : <Navigate to="/" replace />;
}

function HomeRoute() {
  return storedUser()?.role === 'delivery_only'
    ? <Navigate to="/delivery-status" replace />
    : <Dashboard />;
}

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }>
          <Route index element={<HomeRoute />} />
          <Route path="delivery-status" element={<DeliveryAccess><DeliveryStatus /></DeliveryAccess>} />
          <Route path="orders" element={<StandardOnly><Orders /></StandardOnly>} />
          <Route path="reviews" element={<StandardOnly><Reviews /></StandardOnly>} />
          <Route path="refunds" element={<StandardOnly><Refunds /></StandardOnly>} />
          <Route path="wishlist" element={<StandardOnly><Wishlist /></StandardOnly>} />
          <Route path="agents" element={<StandardOnly><Agents /></StandardOnly>} />
          <Route path="settings" element={<StandardOnly><Settings /></StandardOnly>} />
          <Route path="invoices" element={<StandardOnly><Invoices /></StandardOnly>} />
          <Route path="admin" element={<StandardOnly><Admin /></StandardOnly>} />
          <Route path="products" element={<StandardOnly><Products /></StandardOnly>} />
          <Route path="scanner-monitor" element={<ScannerMonitorAccess><ScannerMonitor /></ScannerMonitorAccess>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}
